import { useMemo } from "react";
import {
  Paper,
  Typography,
  Box,
} from "@mui/material";
import WGRTable from "./cont2Table";


//import WGRTotals from "./iohTotals";

export default function WGRShopGroup({
  shop,
  rows,
}) {
  /*
   * Shop Total
   */
  const totals = useMemo(() => {

    return rows.reduce(
      (total, row) => ({

        OB:
          total.OB +
          Number(row.OB || 0),

        DEBIT:
          total.DEBIT +
          Number(row.DEBIT || 0),


        CREDIT:
          total.CREDIT +
          Number(row.CREDIT || 0),


        CB:
          total.CB +
          Number(row.CB || 0),

      }),




      {
        OB: 0,
        DEBIT: 0,
        CREDIT: 0,
        CB: 0,

      }
    );
  }, [rows]);

  return (
    <Paper
      elevation={2}
      sx={{
        overflow: "hidden",
        borderRadius: 2,
      }}
    >

      {/* THIS IS WHERE WGRTable SHOULD BE */}
      <WGRTable
        rows={rows}
        shop={shop}
        totals={totals}
        showTotal={true}
      />


    </Paper>
  );
}

